import React from "react";
import VehicleList from "../components/VehicleList";
import { sampleBuses } from "../lib/vehicles";
import { useTranslation } from "../lib/i18n";
import { useSeo } from "../lib/seo";

export default function BusRentPage() {
  const { t, lang } = useTranslation();
  useSeo({ title: t("seoBusesTitle"), description: t("seoBusesDesc"), path: "/buses", lang });

  return (
    <VehicleList
      items={sampleBuses}
      routePrefix="buses"
      titleKey="buses"
      placeholderKey="busesPlaceholder"
      imageClass="h-56"
    />
  );
}
